import { BookingSearchContainer } from "../../containers";
import './style.scss'

function BookingSearch({ match}) {
    return (
        <div id="bookingPage">
            <BookingSearchContainer match={match}/>
        </div>
    );
}
export default BookingSearch;